var Curriculog = Curriculog || {};

Curriculog.NeedsAttentionQueryParams = (function ($, _, Backbone, NeedsAttentionQueryParams) {

	NeedsAttentionQueryParams = Curriculog.QueryParams.extend({

		defaults: function() {
			// default query for needs attention is requests
			return {
				entity: 0,
				includeEntityChildren: 0,
				ap: 0,
				currentStep: {},
				type: '',
				launchedDateRange: {},
				completedDateRange: {},
				exportedDateRange: {},
				originator: 0,
				status: ['active'],
				name: '',
				permission: '',
				deadline: 0,
				flag: '',
				empty: 0,
				decision: ['request-hold','request-suspend','request-cancel','request-route'],
				showCrosslisting: 1
			};
		},

		getDefaultParams: function(attentionType) {
			var defaults = this.defaults();

			if (_.indexOf(['held','suspended', 'reviewing'], attentionType) !== -1) {
				defaults.status = [attentionType];
				defaults.decision = [];
			}

			if (_.indexOf(['suspended', 'reviewing'], attentionType) !== -1) {
				defaults.showCrosslisting = 0;
			}

			else if (attentionType === 'stuck') {
				defaults.flag = 'stuck';
				defaults.decision = [];
			}

			else if (attentionType === 'empty') {
				defaults.decision = [];
				defaults.empty = 1;
			}

			return defaults;
		},

		allowedStatuses: function() {
			return ['active', 'held', 'suspended', 'reviewing'];
		},

		allowedFlag: function() {
			return true;
		},

		allowedEmpty: function() {
			return true;
		},

		allowedDeadline: function() {
			return true;
		}

	});

	return NeedsAttentionQueryParams;

})($, _, Backbone, Curriculog.NeedsAttentionQueryParams || {});